<ng-container *transloco="let t">
  @if (
    {
      countryErrorMessage: countryErrorMessage$ | async,
      nameErrorMessage: nameErrorMessage$ | async,
      nationalRegistrationNumberErrorMessage:
        nationalRegistrationNumberErrorMessage$ | async,
      vatErrorMessage: vatErrorMessage$ | async,
      phoneErrorMessage: phoneErrorMessage$ | async,
      commentErrorMessage: commentErrorMessage$ | async,
    };
    as data
  ) {
    <fieldset [formGroup]="form">
      <!-- Utländsk organisation -->
      <div class="form-group mt-3 p-0">
        <lib-vinnova-checkboxes
          [checkboxObjects]="[
            { id: 'company-isForeign', label: t('worksite_foreign_company') },
          ]"
          formControlName="isForeign"
          [horizontal]="true"
          singleCheckbox="true"
          [minNumberOfCheckedOptions]="1"
        >
        </lib-vinnova-checkboxes>
      </div>
      <!-- Land -->
      @if (isForeign.value) {
        <div class="form-group">
          <lib-input-container
            formGroupName="address"
            [required]="true"
            [label]="t('worksite_select_country')"
            for="company-country"
            [autoWidth]="false"
            [errorText]="data.countryErrorMessage"
          >
            <lib-vinnova-dropdown
              [id]="'company-country'"
              [placeholder]="t('worksite_select_country')"
              [items]="countries"
              formControlName="country"
              [error]="!!data.countryErrorMessage"
              [required]="true"
            >
            </lib-vinnova-dropdown>
          </lib-input-container>
        </div>
      }
      <!-- Namn -->
      <div class="form-group">
        <lib-input-container
          for="company-name"
          [label]="t('worksite_name')"
          [required]="true"
          [errorText]="data.nameErrorMessage"
        >
          <input
            vinnova-text-input
            id="company-name"
            formControlName="name"
            autocomplete="new-password"
            spellcheck="false"
            [error]="!!data.nameErrorMessage"
          />
        </lib-input-container>
      </div>
      <!-- VAT saknas -->
      @if (isForeign.value) {
        <div class="form-group p-0 my-2">
          <lib-vinnova-checkboxes
            [checkboxObjects]="[
              { id: 'vat-missing', label: t('worksite_vat_missing') },
            ]"
            formControlName="vatMissing"
            [horizontal]="true"
            singleCheckbox="true"
            [minNumberOfCheckedOptions]="1"
          >
          </lib-vinnova-checkboxes>
        </div>
      }
      <!-- Orgnummer -->
      @if (!isForeign.value || vatMissing.value) {
        <div class="form-group">
          @if (!isForeign.value && isProjectPart) {
            <div class="form-group p-0 mb-2">
              <lib-vinnova-checkboxes
                [checkboxObjects]="[
                  {
                    id: 'isIntermediate',
                    label: t('worksite_is_incubators'),
                  },
                ]"
                [horizontal]="true"
                singleCheckbox="true"
                [minNumberOfCheckedOptions]="1"
                (change)="onIntermediateChange($event)"
              >
              </lib-vinnova-checkboxes>
            </div>
          }
          @if (
            vatMissing.value &&
            !country.value &&
            nationalRegistrationNumber.value
          ) {
            <div class="invalid-feedback">
              <lib-icon name="alert-circle" size="x-small"></lib-icon>
              {{ t('worksite_select_country') }}
            </div>
          }
          <lib-input-container
            for="national-registration-number"
            [label]="
              isForeign.value
                ? t('worksite_other_unique_number')
                : t('worksite_registration_number')
            "
            [required]="true"
            [errorText]="data.nationalRegistrationNumberErrorMessage"
          >
            <input
              vinnova-text-input
              [inputType]="
                isForeign.value ? InputType.Text : InputType.Organisationsnummer
              "
              id="national-registration-number"
              formControlName="nationalRegistrationNumber"
              autocomplete="new-password"
              spellcheck="false"
              [error]="!!data.nationalRegistrationNumberErrorMessage"
            />
          </lib-input-container>
        </div>
      }
      <!-- VAT -->
      @if (isForeign.value && !vatMissing.value) {
        <div class="form-group mt-2">
          <ng-template #vatInfo>
            <div class="vat-info-body">
              <span [innerHtml]="t('worksite_vat_info')"> </span>
            </div>
          </ng-template>
          <lib-input-container
            [description]="t('worksite_vat_info')"
            for="company-vat"
            [label]="t('worksite_vat')"
            [required]="true"
            [errorText]="data.vatErrorMessage"
          >
            <!-- <input vinnova-text-input/> -->
            <input
              vinnova-text-input
              id="company-vat"
              formControlName="vat"
              autocomplete="new-password"
              spellcheck="false"
              [error]="!!data.vatErrorMessage"
            />
          </lib-input-container>
        </div>
      }
      @if (
        !selectedCompany && {
          duplicateCompanies: duplicateCompanies$ | async,
        };
        as data
      ) {
        @if (
          data.duplicateCompanies &&
          data.duplicateCompanies.length > 0 &&
          !selectedCompany
        ) {
          <div class="row">
            <div class="col-12 mb-3" id="duplicate-companies">
              @if (
                data.duplicateCompanies[0].bisnodeStatus.code
                  | isValidBisnodeStatus;
                as result
              ) {
                <div class="alert alert-warning m-0">
                  <div class="d-flex align-items-center">
                    <lib-icon name="alert-triangle" size="x-small"></lib-icon>
                    <div class="ms-2">
                      <p class="m-0">{{ t('worksite_organisation_exist') }}.</p>
                      <p class="m-0">
                        {{ t('worksite_organisation_exist_info') }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card mt-2">
                  <div class="d-flex justify-content-between mt-1">
                    <div>
                      <p class="m-0">{{ data.duplicateCompanies[0].name }}</p>
                      <p class="m-0">
                        <small> {{ nationalRegistrationNumber.value }}</small>
                      </p>
                    </div>
                    <button
                      vinnova-button-text
                      type="button"
                      (click)="onSelectCompany(data.duplicateCompanies[0])"
                    >
                      {{ t('worksite_select') }}
                    </button>
                  </div>
                </div>
              } @else {
                <div class="alert alert-warning m-0">
                  <div class="d-flex align-items-center">
                    <lib-icon name="alert-triangle" size="x-small"></lib-icon>
                    <div class="ms-2">
                      <p class="m-0">
                        {{ t('worksite_organisation_exist_inactive') }}
                        <lib-icon
                          name="help-circle"
                          size="x-small"
                          [libTooltip]="
                            t('worksite_organisation_exist_inactive_info')
                          "
                        ></lib-icon>
                      </p>
                      @if (
                        data.duplicateCompanies[0].legalForm | isValidLegalForm
                      ) {
                        <p class="m-0">
                          {{ t('worksite_organisation_exist_select') }}
                        </p>
                      }
                    </div>
                  </div>
                </div>
                <div class="card mt-2">
                  <div class="d-flex justify-content-between mt-1 flex-column">
                    <div>
                      <p class="m-0">{{ data.duplicateCompanies[0].name }}</p>
                      <p class="m-0">
                        <small> {{ nationalRegistrationNumber.value }}</small>
                      </p>
                    </div>
                    @if (
                      data.duplicateCompanies[0].legalForm | isValidLegalForm
                    ) {
                      <div class="d-flex justify-content-between mt-1">
                        <div class="p-0">
                          <lib-vinnova-checkboxes
                            [checkboxObjects]="[
                              {
                                id: 'hideOverride',
                                label: t('worksite_organisation_exist_cerify'),
                              },
                            ]"
                            [horizontal]="true"
                            [checked]="!hideOverrideSelectButton"
                            singleCheckbox="true"
                            [minNumberOfCheckedOptions]="1"
                            (change)="
                              hideOverrideSelectButton =
                                !hideOverrideSelectButton
                            "
                          >
                          </lib-vinnova-checkboxes>
                          <p class="text-muted m-0">
                            <small>{{
                              t('worksite_organisation_exist_contact')
                            }}</small>
                          </p>
                        </div>
                        <div class="align-self-end">
                          <button
                            vinnova-button-text
                            [disabled]="hideOverrideSelectButton"
                            type="button"
                            (click)="
                              onSelectCompany(data.duplicateCompanies[0])
                            "
                          >
                            {{ t('worksite_select') }}
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <!-- </ng-container> -->
      }
      <!-- Adress -->
      <lib-create-address
        [form]="addressForm"
        [name]="'company'"
        [isForeign]="isForeign.value"
      ></lib-create-address>
      <!-- Telefonnummer -->
      <div class="form-group">
        <lib-input-container
          for="company-phone"
          [label]="t('worksite_phone')"
          [errorText]="data.phoneErrorMessage"
        >
          <lib-text-input-phone
            [id]="'company-phone'"
            formControlName="phone"
            [error]="!!data.phoneErrorMessage"
          >
          </lib-text-input-phone>
        </lib-input-container>
      </div>
      <!-- Kommentar -->
      <div class="form-group">
        <lib-input-container
          for="company-comment"
          [required]="true"
          [label]="t('worksite_company_create_reason')"
          [errorText]="data.commentErrorMessage"
        >
          <textarea
            vinnova-textarea
            [required]="true"
            id="company-comment"
            formControlName="comment"
            [error]="!!data.commentErrorMessage"
          ></textarea>
        </lib-input-container>
      </div>
    </fieldset>
  }
</ng-container>
